import { render, staticRenderFns } from "./mid.vue?vue&type=template&id=fa545efe"
import script from "./mid.vue?vue&type=script&lang=js"
export * from "./mid.vue?vue&type=script&lang=js"
import style0 from "./mid.vue?vue&type=style&index=0&id=fa545efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports